module.exports = __webpack_public_path__ + "img/Total Outward Count.042745fa.svg";